import { useState } from "react";

import { Validate } from "./Validation";
import _ from "lodash";
import TextField from "@mui/material/TextField";

interface IPasswordFeildProps {
  autoFocus?: boolean;
  id?: string;
  criteria?: string[];
  label?: string;
  onInput: (value: string) => void;
}

const PasswordFeild = ({ autoFocus, id, criteria = [], label, onInput }: IPasswordFeildProps) => {
  const [error, setError] = useState(true);
  const [msg, setMsg] = useState("Required!");

  const handleInput = (value: string) => {
    const validation = Validate(value, criteria);
    setError(validation.err);
    setMsg(validation.msg);
    if (!validation.err) onInput(value);
  };

  return <TextField error={error} autoFocus={autoFocus} margin="dense" id={id} label={label} type="password" fullWidth onChange={(e) => handleInput(e.target.value)} helperText={msg && msg} />;
};

export default PasswordFeild;
